<script>
import { getContext } from 'svelte';
import Line from 'svelte-chartjs/src/Line.svelte';
import FixedContent from '../FixedContent/FixedContent.svelte';
import ContentBox from '../ContentBox/ContentBox.svelte';

const state = getContext('state');

const getLabels = () => (
  $state.data.matchDisplay.map((match) => `${new Date(match.started_at * 1000).getDate()}/${new Date(match.started_at * 1000).getMonth() + 1}/${new Date(match.started_at * 1000).getFullYear()}`).reverse()
);

const getKillsData = () => (
  $state.data.matchDisplay.map((match) => match.player.player_stats.Kills).reverse()
);

const getDeathsData = () => (
  $state.data.matchDisplay.map((match) => match.player.player_stats.Deaths).reverse()
);

getKillsData();

let dataLine = {
    labels: getLabels(),
    datasets: [
      {
        label: "Kills",
        lineTension: 0.3,
        fill: false,
        backgroundColor: "rgba(225, 204,230, .3)",
        borderColor: "rgb(16, 185, 129)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        showLine: true,
        pointBorderColor: "rgb(16, 185, 129)",
        pointBackgroundColor: "rgb(16, 185, 129)",
        pointBorderWidth: 10,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgb(0, 0, 0)",
        pointHoverBorderColor: "rgba(220, 220, 220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: getKillsData(),
      },
      {
        label: "Deaths",
        lineTension: 0.3,
        fill: false,
        backgroundColor: "rgba(225, 204,230, .3)",
        borderColor: "rgb(239, 68, 68)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        showLine: false,
        pointBorderColor: "rgb(239, 68, 68)",
        pointBackgroundColor: "rgb(239, 68, 68)",
        pointBorderWidth: 10,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgb(0, 0, 0)",
        pointHoverBorderColor: "rgba(220, 220, 220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: getDeathsData(),
      }
    ]
  };
</script>

<FixedContent>
  <ContentBox>
    <Line data={dataLine} options={{ responsive: true }}/>
  </ContentBox>
</FixedContent>
